"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.877 16.315a7.116 7.116 0 111.438-1.438l4.185 4.185-1.438 1.438-4.185-4.185zm.821-5.7a5.083 5.083 0 11-10.165 0 5.083 5.083 0 0110.165 0z" }), "Search");
//# sourceMappingURL=Search.js.map